import { PUBLICATION_INTERNAL_PAGE_SLUGS } from '@shared/constants'

import { validateWorkspaceName } from '@shared/validation'

export const navigateAuthenticatedUserToSubdomain = (subdomain = ''): void => {
  const protocol = window.location.protocol
  const newUrl = `${protocol}//${subdomain}.${process.env.NEXT_PUBLIC_APP_DOMAIN}`
  window.location.href = newUrl
}

/**
 * Checks whether a domain is valid
 */
export const testDomainIsValid = (domainName: string): boolean => {
  return validateWorkspaceName(domainName)
}

export type PublicationRouteParams = { params: { siteId: string; brand: string; workspace } }
export type WorkspaceRouteParams = { params: { workspace: string } }

export const buildAuthenticatedRoute = ({
  workspace,
  brand,
  siteId,
  pageSlug,
  sectionPageId,
  tagPageId,
  writerPageId,
  storyPageId,
  spotlightPageId,
}: {
  workspace: string
  brand?: string
  siteId?: string
  pageSlug?: string
  storyPageId?: string
  sectionPageId?: string
  tagPageId?: string
  writerPageId?: string
  spotlightPageId?: string
}): string => {
  if (workspace && brand && siteId && sectionPageId) {
    return `/${workspace}/${encodeURI(brand)}/${siteId}${PUBLICATION_INTERNAL_PAGE_SLUGS.sections}/${sectionPageId}`
  } else if (workspace && brand && siteId && tagPageId) {
    return `/${workspace}/${encodeURI(brand)}/${siteId}${PUBLICATION_INTERNAL_PAGE_SLUGS.tags}/${tagPageId}`
  } else if (workspace && brand && siteId && writerPageId) {
    return `/${workspace}/${encodeURI(brand)}/${siteId}${PUBLICATION_INTERNAL_PAGE_SLUGS.writers}/${writerPageId}`
  } else if (workspace && brand && siteId && storyPageId) {
    return `/${workspace}/${encodeURI(brand)}/${siteId}${PUBLICATION_INTERNAL_PAGE_SLUGS.stories}/${storyPageId}`
  } else if (workspace && brand && siteId && spotlightPageId) {
    return `/${workspace}/${encodeURI(brand)}/${siteId}${PUBLICATION_INTERNAL_PAGE_SLUGS.spotlight}/${spotlightPageId}`
  } else if (workspace && brand && siteId && pageSlug) {
    return `/${workspace}/${encodeURI(brand)}/${siteId}${pageSlug}`
  } else if (workspace && brand && siteId) {
    return `/${workspace}/${encodeURI(brand)}/${siteId}`
  } else if (workspace && brand) {
    return `/${workspace}/${encodeURI(brand)}`
  } else if (workspace && pageSlug) {
    return `/${workspace}${pageSlug}`
  }
  return `/${workspace}`
}
